import React from "react";

import { Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

import { useAppState } from "../../../../../context/StateContext";
import { Color } from "../../../../Form/Button";
import { GroupedButtons } from "../../../../Generic/GroupedButtons";
import { ShipmentTabs } from "../../../utils";
import useStyles from "./styles";

interface Props {
  onSave: () => void;
  onCancel: () => void;
  loading?: boolean;
  viewOnly?: boolean;
  id?: number;
  showModal: (value: boolean) => void;
  leftPanelSelected: string;
}

const ShipmentActionButtons = (props: Props) => {
  const { loading, onSave, onCancel, viewOnly, id, showModal, leftPanelSelected } = props;
  const { isSupplierPortal, currentUser, isFMVersion } = useAppState();
  const classes = useStyles();
  const { t: translate } = useTranslation();

  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const deleteButton = {
    name: "delete",
    action:
      leftPanelSelected === ShipmentTabs.DETAILS && currentUser?.isAdmin && id && isFMVersion
        ? () => showModal(true)
        : undefined,
    disabled: loading || isSupplierPortal || viewOnly,
    loading,
    dataCy: "delete-order-button",
    className: classes.deleteButton,
    customColor: Color.ERROR,
    children: (
      <Stack alignItems="center" justifyContent="center" width="100%" direction="row" spacing={1}>
        <DeleteIcon />
        <Box>
          {translate("delete")} {translate("shipment")}
        </Box>
      </Stack>
    ),
  };

  return (
    <Box
      className={classes.buttons}
      display="flex"
      flexDirection={"row"}
      justifyContent={"space-between"}
    >
      <Box
        display="flex"
        flexDirection={"row"}
        justifyContent={"flex-end"}
        className={classes.buttons}
      >
        <GroupedButtons
          buttons={[
            {
              name: "cancel",
              action: onCancel,
              disabled: loading,
              variant: "text",
              customColor: Color.CANCEL,
              text: translate("cancel"),
            },
            {
              name: "save",
              action: onSave,
              disabled: viewOnly,
              loading,
              customColor: Color.SUCCESS,
              text: !id ? translate("create") : translate("save"),
            },
          ]}
        ></GroupedButtons>
      </Box>
    </Box>
  );
};

export default ShipmentActionButtons;
